import styled from 'styled-components';
import { Divider, List } from 'antd';


export const FiltersContainer = styled.div`
  background-color: #f6f6f9;
  display: flex;
  padding: 0.625rem;
  margin: 0.625rem 0;
  border-radius: 0.25rem;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;


export const SectionTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: auto;
  margin-bottom: auto
`;


export const SectionTitle = styled.div`
  font-size: 16px;
  color: rgb(62, 76, 89);
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  letter-spacing: -0.01em;
  font-weight: 600;
  margin-top: auto;
  margin-bottom: 0px;
`;



export const SectionTitleActions = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: auto;
    margin-bottom: 0px;
`;

export const NoSpaceDivider = styled(Divider)`
  margin: 0px !important;
  margin-top: 0.3em !important;
`;


export const HighlightListItem = styled(List.Item)`
  padding-left: 1em !important;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #f0f0f0; /* light grey or any color you prefer */
  }
`;


export const SettlementListItem = styled(List.Item)`
  display: flow !important;
`;


interface DataDisplayContainerProps {
  columns?: number; // Optional, defaults to 3
  columnSize?: number;
}

export const DataDisplayContainer = styled.div<DataDisplayContainerProps>`
  display: grid;
  grid-template-columns: ${({ columns = 3, columnSize = 0.3 }) => `repeat(${columns}, ${columnSize}fr)`};
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin-bottom: 1.6rem;
`;

